import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2h-4v2H3v2h18V4h-7V2zM5 9h14v9.8c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C17.48 22 16.92 22 15.8 22H8.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C5 20.48 5 19.92 5 18.8V9z" }));
export default createSvgIcon(iconPath, "Delete");
//# sourceMappingURL=DeleteIcon.js.map